<template>
  <div style="margin: 0;padding: 0;">
    <el-header style="height: 50px;margin: 0;padding: 0;color: #ffffff;width: 100%;overflow: hidden;">
      <div style="width: 100%;min-height: 45px;max-height: 55px;">
        <div style="display: inline-block;margin-right: 20px;vertical-align: top;">
          <el-input v-model="serchat" placeholder="请输入客户名称" maxlength="30" style="width: 150px;"></el-input>
          <el-dropdown split-button type="primary" @command="commandEvent">
            <span v-html="dropdownTitle"></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="全部">全部</el-dropdown-item>
              <el-dropdown-item v-for="(item,index) in dropdownList" :key="index" :command="item.label">{{item.label}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="isAjax" plain>查询</el-button>
        </div>
        <div style="display: inline-block;margin-right: 20px;">
          <NumberGrow :title="title1" :dw="dw1" :value="NumberGrow1" ref="N1"></NumberGrow>
        </div>
        <div style="display: inline-block;margin-right: 20px;">
          <NumberGrow :title="title2" :dw="dw2" :value="NumberGrow2" ref="N2"></NumberGrow>
        </div>
        <div style="display: inline-block;margin-right: 20px;">
          <NumberGrow :title="title3" :dw="dw3" :value="NumberGrow3" ref="N3"></NumberGrow>
        </div>
        <div style="display: inline-block;margin-right: 20px;">
          <NumberGrow :title="title4" :dw="dw3" :value="NumberGrow4" ref="N4"></NumberGrow>
        </div>
        <el-button type="success" size="small" style="float: right;" @click="tp" v-show="isTpShow">投屏<i class="el-icon-copy-document el-icon--right"></i></el-button>
      </div>
    </el-header>
    <el-container>
      <el-main>
        <select style="position: fixed;top:55px;left: 10px;z-index: 1;" id="checkValue">
          <option>全部</option>
          <option>2025</option>
          <option>2024</option>
          <option>2023</option>
          <option>2022</option>
          <option>2021</option>
          <option>2020</option>
          <option>2019</option>
          <option>2018</option>
          <option>2017</option>
        </select>
        <br/>
        <div style="width: 100%;">
          <div id="myChart_orderNumber" :style="divHeight">
          </div>
          <div id="myChart_orderPrice" :style="divHeight">
          </div>
          <div id="myChart_orderMonthNumber" :style="divHeight">
          </div>
          <div id="myChart_orderMonthPrice" :style="divHeight">
          </div>
        </div>
      </el-main>
      <el-footer>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  import EchaAverage from '@/assets/echaAverage.js'
  import PurplePassion from '@/assets/purplePassion.js'
  import NumberGrow from '@/components/NumberGrow.vue'
  export default {
    data () {
      return {
        title1:"订单总成交金额",
        dw1:"元",
        title2:"订单总数",
        dw2:"张",
        title3:"采购商总数",
        dw3:"位",
        title4:"下单客户总数",
        NumberGrow1:0,
        NumberGrow2:0,
        NumberGrow3:0,
        NumberGrow4:0,
        divHeight:{
          width: '50%', height: '315px',float:'left'
        },
        serchat:"",
        dropdownTitle:"请选择",
        dropdownList:[],
        rowList:[],
        orderNumber:[],
        orderDeal:[],
        orderSales:[],
        number:[],
        placeNumber:[],

        rowMonthList:[],
        orderMonthNumber:[],
        orderMonthDeal:[],
        orderMonthSales:[],
        numberMonth:[],
        placeMonthNumber:[],

        timeInterval:null,
        myChart_orderNumber:null,
        myChart_orderPrice:null,
        myChart_orderMonthNumber:null,
        myChart_orderMonthPrice:null,
        dialogFormVisible:true,
        userName:"",
        isGetMess:false,
        isTpShow:true,
      }
    },
    components: {
      NumberGrow
    },
    methods:{
      commandEvent(command) {
        this.dropdownTitle = command
      },
      addClass:async function(){
        await this.$axios.post('/data/addClass',{
          uid:""
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.dropdownList = response.data[0];
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      //随机生成颜色
      handleColors(){
        //定义字符串变量colorValue存放可以构成十六进制颜色值的值
        var colorValue="0,1,2,3,4,5,6,7,8,9,a,b,c,d,e,f";
        //以","为分隔符，将colorValue字符串分割为字符数组["0","1",...,"f"]
        var colorArray = colorValue.split(",");
        var color="#";//定义一个存放十六进制颜色值的字符串变量，先将#存放进去
        //使用for循环语句生成剩余的六位十六进制值
        for(var i=0;i<6;i++){
          //colorArray[Math.floor(Math.random()*16)]随机取出
          // 由16个元素组成的colorArray的某一个值，然后将其加在color中，
          //字符串相加后，得出的仍是字符串
          color+=colorArray[Math.floor(Math.random()*16)];
        }
        return color;
      },
      isAjax:async function(){
        var c_t = document.getElementById("checkValue").value;
        await this.$axios.post('/data/getYearData',{
          d:this.dropdownTitle,
          s:this.serchat,
          t:c_t
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            var tableData = response.data[0];
            var tableData1 = response.data[1];
            this.rowList = [];
            this.orderNumber = [];
            this.number = [];
            this.orderDeal = [];
            this.orderSales = [];
            this.placeNumber = [];

            this.rowMonthList = [];
            this.orderMonthNumber = [];
            this.numberMonth = [];
            this.orderMonthDeal = [];
            this.orderMonthSales = [];
            this.placeMonthNumber = [];

            let all1 = 0,all2 = 0,all3 =0,all4 =0;

            for(var i=0;i<tableData.length;i++){
              all3+=parseInt(tableData[i].numberAll);
              this.number.push(tableData[i].numberAll)
              all2+=parseInt(tableData[i].orderNumberAll);
              this.orderNumber.push(tableData[i].orderNumberAll)
              all4+=parseInt(tableData[i].placeNumberAll);
              this.placeNumber.push(tableData[i].placeNumberAll)
              var _a_ = parseFloat(tableData[i].orderSalesAll).toFixed(2);
              this.orderSales.push(parseFloat(_a_))
              var _b_ = parseFloat(tableData[i].orderDealAll).toFixed(2);
              all1+=parseFloat(_b_);
              this.orderDeal.push(parseFloat(_b_))
              this.rowList.push(tableData[i]._id.dataTime)
            }

            this.NumberGrow1 = parseFloat(parseFloat(all1).toFixed(2));
            this.NumberGrow2 = parseInt(all2);
            this.NumberGrow3 = parseInt(all3);
            this.NumberGrow4 = parseInt(all4);
            this.$nextTick (function () {
              this.$refs.N1.numberGrow();
              this.$refs.N2.numberGrow();
              this.$refs.N3.numberGrow();
              this.$refs.N4.numberGrow();
            })


            for(var i=0;i<tableData1.length;i++){
              this.numberMonth.push(tableData1[i].numberAll)
              this.orderMonthNumber.push(tableData1[i].orderNumberAll)
              this.placeMonthNumber.push(tableData1[i].placeNumberAll)
              var _a_ = parseFloat(tableData1[i].orderSalesAll).toFixed(2);
              this.orderMonthSales.push(parseFloat(_a_))
              var _b_ = parseFloat(tableData1[i].orderDealAll).toFixed(2);
              this.orderMonthDeal.push(parseFloat(_b_))
              this.rowMonthList.push(tableData1[i]._id.dataTime)
            }
            var data1 = [
              {
                name: '新增采购商数量',
                type: 'bar',
                barGap: 0,
                label: "新增采购商数量",
                itemStyle:{
                  normal:{
                    //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                    color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                      offset: 0,
                      color: this.handleColors()
                    }, {
                      offset: 1,
                      color: this.handleColors()
                    }])
                  }
                },
                data: this.number,
                markPoint : {
                  data : [
                    {type : 'max', name: '最大值'},
                    {type : 'min', name: '最小值'}
                  ]
                }
              },
              {
                name: '订单总数量',
                type: 'bar',
                label: "订单总数量",
                itemStyle:{
                  normal:{
                    //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                    color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                      offset: 0,
                      color: this.handleColors()
                    }, {
                      offset: 1,
                      color: this.handleColors()
                    }])
                  }
                },
                data: this.orderNumber,
                markPoint : {
                  data : [
                    {type : 'max', name: '最大值'},
                    {type : 'min', name: '最小值'}
                  ]
                }
              },
              {
                name: '下单客户数',
                type: 'bar',
                label: "下单客户数",
                itemStyle:{
                  normal:{
                    //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                    color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                      offset: 0,
                      color: this.handleColors()
                    }, {
                      offset: 1,
                      color: this.handleColors()
                    }])
                  }
                },
                data: this.placeNumber,
                markPoint : {
                  data : [
                    {type : 'max', name: '最大值',color:'red'},
                    {type : 'min', name: '最小值'}
                  ]
                }
              }
            ]
            var data2 = [
              {
                name: '订单总金额',
                type: 'bar',
                label: "订单总金额",
                itemStyle:{
                  normal:{
                    //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                    color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                      offset: 0,
                      color: this.handleColors()
                    }, {
                      offset: 1,
                      color: this.handleColors()
                    }])
                  }
                },
                data: this.orderSales,
                markPoint : {
                  data : [
                    {type : 'max', name: '最大值'},
                    {type : 'min', name: '最小值'}
                  ]
                }
              },
              {
                name: '订单总成交额',
                type: 'bar',
                label: "订单总成交额",
                itemStyle:{
                  normal:{
                    //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                    color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                      offset: 0,
                      color: this.handleColors()
                    }, {
                      offset: 1,
                      color: this.handleColors()
                    }])
                  }
                },
                data: this.orderDeal,
                markPoint : {
                  data : [
                    {type : 'max', name: '最大值'},
                    {type : 'min', name: '最小值'}
                  ]
                }
              }
            ]
            var data3 = [
              {
                name: '新增采购商数量',
                type: 'bar',
                barGap: 0,
                label: {
                  formatter: function(params) {
                    if (params.value > 0) {
                      return params.value;
                    } else {
                      return '';
                    }
                  }
                },
                itemStyle:{
                  normal:{
                    //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                    color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                      offset: 0,
                      color: this.handleColors()
                    }, {
                      offset: 1,
                      color: this.handleColors()
                    }])
                  }
                },
                data: this.numberMonth,
                markPoint : {
                  data : [
                    {type : 'max', name: '最大值'},
                    {type : 'min', name: '最小值'}
                  ]
                }
              },
              {
                name: '订单总数量',
                type: 'bar',
                label: {
                  formatter: function(params) {
                    if (params.value > 0) {
                      return params.value;
                    } else {
                      return '';
                    }
                  }
                },
                itemStyle:{
                  normal:{
                    //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                    color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                      offset: 0,
                      color: this.handleColors()
                    }, {
                      offset: 1,
                      color: this.handleColors()
                    }])
                  }
                },
                data: this.orderMonthNumber,
                markPoint : {
                  data : [
                    {type : 'max', name: '最大值'},
                    {type : 'min', name: '最小值'}
                  ]
                }
              },
              {
                name: '下单客户数',
                type: 'bar',
                label: {
                  formatter: function(params) {
                    if (params.value > 0) {
                      return params.value;
                    } else {
                      return '';
                    }
                  }
                },
                itemStyle:{
                  normal:{
                    //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                    color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                      offset: 0,
                      color: this.handleColors()
                    }, {
                      offset: 1,
                      color: this.handleColors()
                    }])
                  }
                },
                data: this.placeMonthNumber,
                markPoint : {
                  data : [
                    {type : 'max', name: '最大值',color:'red'},
                    {type : 'min', name: '最小值'}
                  ]
                }
              }
            ]
            var data4 = [
              {
                name: '订单总金额',
                type: 'bar',
                label: "订单总金额",
                itemStyle:{
                  normal:{
                    //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                    color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                      offset: 0,
                      color: this.handleColors()
                    }, {
                      offset: 1,
                      color: this.handleColors()
                    }])
                  }
                },
                data: this.orderMonthSales,
                markPoint : {
                  data : [
                    {type : 'max', name: '最大值'},
                    {type : 'min', name: '最小值'}
                  ]
                }
              },
              {
                name: '订单总成交额',
                type: 'bar',
                label: "订单总成交额",
                itemStyle:{
                  normal:{
                    //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                    color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                      offset: 0,
                      color: this.handleColors()
                    }, {
                      offset: 1,
                      color: this.handleColors()
                    }])
                  }
                },
                data: this.orderMonthDeal,
                markPoint : {
                  data : [
                    {type : 'max', name: '最大值'},
                    {type : 'min', name: '最小值'}
                  ]
                }
              }
            ]
            this.myChart_orderNumber.hideLoading();
            this.myChart_orderNumber.setOption(this.dataLine(data1,this.rowList,['新增采购商数量', '订单总数量', '下单客户数']),true);
            this.myChart_orderPrice.hideLoading();
            this.myChart_orderPrice.setOption(this.dataLine(data2,this.rowList,['订单总金额', '订单总成交额']),true);
            this.myChart_orderMonthNumber.hideLoading();
            this.myChart_orderMonthNumber.setOption(this.dataLine(data3,this.rowMonthList,['新增采购商数量', '订单总数量', '下单客户数']),true);
            this.myChart_orderMonthPrice.hideLoading();
            this.myChart_orderMonthPrice.setOption(this.dataLine(data4,this.rowMonthList,['订单总金额', '订单总成交额']),true);
            this.divHeight.height = (window.innerHeight-58)/2+"px";
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      tp(){
        window.open(location.href+"?t=1","_blank");
      },
      openRealTime(){

      },
      dataLine(data,xdata,ldata){
        return {
          color: ['#EDB21A', '#87F7CF', '#FC97AF'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: ldata
          },
          toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
              mark: {show: true},
              dataView: {show: true, readOnly: false},
              magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
              restore: {show: true},
              saveAsImage: {show: true}
            }
          },
          calculable: true,
          grid:{
            top:"50px",
            left:"50px",
            right:"15px",
            bottom:"50px"
          },
          xAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              data: xdata,
            }
          ],
          grid:{
            x: 90, //默认是80px
            y: 60, //默认是60px
            x2: 40, //默认80px
            y2: 45 //默认60px
          },
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                formatter: function (value) {
                  value = value/10000;
                  return value+"万";
                }
              }
            }
          ],
          series: data
        }
      },
      GetUrlParms() {
        var args = new Object();
        var query = location.search.substring(1); //获取查询串
        var pairs = query.split("&"); //在逗号处断开
        for (var i = 0; i < pairs.length; i++) {
          var pos = pairs[i].indexOf('='); //查找name=value
          if (pos == -1) continue; //如果没有找到就跳过
          var argname = pairs[i].substring(0, pos); //提取name
          var value = pairs[i].substring(pos + 1); //提取value
          args[argname] = value; //存为属性
        }
        return args;

      }
    },
    mounted(){
      var args=this.GetUrlParms();
      var t = args["t"];
      if(t != null){
        if(t == 1){
          this.isTpShow = false;
        }
      }
      this.addClass();
      this.$echarts.registerTheme('purple-passion', PurplePassion)
      this.myChart_orderNumber = this.$echarts.init(document.getElementById('myChart_orderNumber'),'purple-passion')
      this.myChart_orderPrice = this.$echarts.init(document.getElementById('myChart_orderPrice'),'purple-passion')
      this.myChart_orderMonthNumber = this.$echarts.init(document.getElementById('myChart_orderMonthNumber'),'purple-passion')
      this.myChart_orderMonthPrice = this.$echarts.init(document.getElementById('myChart_orderMonthPrice'),'purple-passion')
      this.isAjax();
    },
    watch: {
    },
    beforeCreate () {

      document.querySelector('body').setAttribute('style', 'background-color:#5B5C6E')

    },
    computed:{
    }
  }
</script>
<style scoped>
  .el-main{
    overflow: hidden;
    padding: 0 !important;
    margin: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/dataStatistics/summaryData.vue